<template>
  <body>
    <ModalAutores :autores="autores" v-show="modalAutores"
      @cerrar="cerrarModal"
      @recargar="recargarAutores"
      @AddAutor="otroAutor"/>
    <aside class="Blk-1">
      <img class="imagen" :src="elementoVista.imagen">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Elementos registrados</p>
          <select name="elementos" id="" class="campo"
            :disabled = 'habBotAndCamp.habLib'
            v-model="elementoSel" @change.prevent="mostrarDatosElemento(elementoSel._id)">
            <option v-for="elemento in listaElementos"
              :key="elemento._id"
              :value="elemento">
              {{elemento.titulo}}
            </option>
          </select>
        </div>
        <form @change="cambioForm">
          <div class="Blk-Campo">
            <p>Título*</p>
            <textarea name="titulo" class="campo" ref="nombreElemento" rows="2"
              :disabled = '!habBotAndCamp.habLib'
              v-model.trim="elementoVista.titulo"
              spellcheck="false">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Autor(es)</p>
            <div class="campo" @change="cambioAutores" >{{autoresVista}}</div>
            <div class="botonesAut">
              <button class="botAut" @click.prevent="addAutor" :disabled = '!habBotAndCamp.habLib'>+</button>
              <button class="botAut" @click.prevent="delAutor" :disabled = '!habBotAndCamp.habLib'> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Editor</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="elementoVista.editorial"
              :disabled = '!habBotAndCamp.habLib'
            >
          </div>
          <div class="Blk-Campo">
            <p>Descripción</p>
            <textarea name="descripcion" id="descripcion"  class="campo" rows="5"
              :disabled = '!habBotAndCamp.habLib'
              spellcheck="false"
              v-model.trim="elementoVista.descripcion">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <textarea name="palabrasClave" class="campo" rows="2" id=""
              :disabled = '!habBotAndCamp.habLib'
              v-model.trim="elementoVista.palsClave">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Ciudad</p>
            <input type="text" name="ciudad" class="campo"
              v-model.trim="elementoVista.ciudad"
              :disabled = '!habBotAndCamp.habLib'>
            <p>País</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="elementoVista.pais"
              :disabled = '!habBotAndCamp.habLib'>
            </div>
          <div class="Blk-Campo">
            <p>Año</p>
            <input type="text" name="anyo" class="campo"
              v-model.trim="elementoVista.anyo"
              :disabled = '!habBotAndCamp.habLib'>
            <p>Tipo elemento</p>
            <input type="text" name="tipo" class="campo" list="tipos" autocomplete="off"
              v-model.trim="elementoVista.tipoElemento"
              :disabled = '!habBotAndCamp.habLib'>
            <datalist id="tipos">
              <option v-for="tipoMiscel in tiposMiscel"
                :key="tipoMiscel.Id"
                :value="tipoMiscel">
                {{tipoMiscel.tipo}}
              </option>
            </datalist>
          </div>
          <div class="Blk-Campo">
            <p>Idioma</p>
            <input type="text" name="idioma" class="campo" list="idiomas" autocomplete="off"
              v-model.trim="elementoVista.idioma"
              :disabled = '!habBotAndCamp.habLib'>
            <datalist id="idiomas">
              <option value="Español">Español</option>
              <option value="Francés">Francés</option>
              <option value="Italiano">Italiano</option>
              <option value="Inglés">Inglés</option>
              <option value="Japonés">Japonés</option>
              <option value="Portugués">Portugués</option>
              <option value="Catalán">Catalán</option>
            </datalist>
            <p>Tamaño</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="elementoVista.size"
              :disabled = '!habBotAndCamp.habLib'>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Formato papel</p>
              <input type="checkbox" name="fPapel"
                v-model.trim="elementoVista.papel"
                :disabled = '!habBotAndCamp.habLib'>
            </div>
            <div class="check">
              <p>Formato electrónico</p>
              <input type="checkbox" name="fElec"
                v-model.trim="elementoVista.digital"
                :disabled = '!habBotAndCamp.habLib'>
            </div>
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.habLib'
                v-model.trim="elementoVista.reservado">
            </div>
          </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1" :disabled = '!habBotAndCamp.habLib' class="inputfile" @change="cargarPortada"/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar imagen</p>
          </div>
          <img class="imagen2" :src="elementoVista.imagen">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMas"
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @nuevo="nuevo"
        @editar="editar"
        @del="borrar"
        @save="save"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalAutores from '../components/ModalAutores.vue'
import axios from 'axios'
export default {
  name: 'FormMiscel',
  components: { BotonesCRUD, ModalAutores },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getListaElementos() // Trae lista de nombres de elementos sin otros datos
    this.getAutores() // Trae la lista de autores
    this.activaModo('INI')
  },
  data () {
    return {
      modalAutores: false,
      elementoSel: [],
      elementoSelBkUp: [],
      listaElementos: [],
      elementoVista: {},
      elementoVistaBkUp: {},
      tiposMiscel: [],
      autores: [],
      autoresMiscel: [],
      autoresMiscelBkUp: [],
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        habLib: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getListaElementos () {
      try {
        const url = `${this.URLbase}/miscelaneos/listaMiscel`
        const res = await fetch(url)
        this.listaElementos = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    mostrarDatosElemento (IdElemento) {
      this.getDatosElemento(IdElemento)
      this.activaModo('S')
    },
    async getDatosElemento (IdSelecc) {
      try {
        const url = `${this.URLbase}/miscelaneos/getMiscelData`
        const miscelId = { _id: IdSelecc }
        const res = await axios.post(url, miscelId)
        this.elementoVista = res.data
        this.autoresMiscel = res.data.autores
      } catch (error) {
        alert(error)
      }
    },
    editar () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.elementoVistaBkUp = JSON.parse(JSON.stringify(this.elementoVista))
        this.autoresMiscelBkUp = JSON.parse(JSON.stringify(this.autoresMiscel))
        this.elementoSelBkUp = this.elementoSel
        this.activaModo('EDI')
      } else {
        // Si se cancela, resatura los valores previos
        this.elementoVista = JSON.parse(JSON.stringify(this.elementoVistaBkUp))
        this.autoresMiscel = JSON.parse(JSON.stringify(this.autoresMiscelBkUp))
        this.elementoSel = this.elementoSelBkUp
        this.activaModo('S')
      }
    },
    cambioForm () {
      if (this.IsModoSalirMas && this.minDataLib) {
        this.activaModo('MASs')
      }
      if (this.IsModoSalirEdi && this.minDataLib) {
        this.activaModo('EDIs')
      }
    },
    async borrar () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de este misceláneo. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C')
      if (response === 'borrar') {
        const url = `${this.URLbase}/miscelaneos/deleteMiscel`
        const miscelId = { _id: this.elementoVista._id }
        try {
          const result = await axios.post(url, miscelId, {
            headers: {
              authorization: this.token
            }
          })
          // console.log('Resultado:', result.status)
          switch (result.status) {
            case 200:
              this.blanquearElementoVista()
              this.alertJoa('¡Registro borrado con éxito!', 'S')
              this.getListaElementos()
              break
            case 500:
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
              break
            default:
              this.alertJoa('Algo salió mal, intenta otra vez', 'E')
          }
        } catch (error) {
          // console.error(error)
          this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
        }
      }
    },
    async save () {
      this.elementoVista.autores = this.autoresMiscel
      try {
        const url = `${this.URLbase}/miscelaneos/save`
        const miscelData = this.elementoVista
        axios.post(url, miscelData)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                this.getListaElementos()
                break
            }
          })
      } catch (error) {
        alert(error)
      }
      this.IsModoSalirMas = false
      this.IsModoSalirEdi = false
      this.blanquearElementoVista()
      this.activaModo('INI')
    },
    async getAutores () {
      try {
        const url = `${this.URLbase}/autores/listAutores`
        const res = await fetch(url)
        this.autores = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    addAutor () {
      if (this.elementoVista.titulo) { this.modalAutores = true }
    },
    recargarAutores () {
      this.getAutores()
    },
    // Elimina el último autor asociado al elemento
    delAutor () {
      this.autoresMiscel.pop()
    },
    // Añade los autores en orden de un elemento
    otroAutor (autorRecibido) {
      if (!this.autoresMiscel.includes(autorRecibido)) {
        this.autoresMiscel.push(autorRecibido)
      }
    },
    cerrarModal () {
      this.modalAutores = false
    },
    nuevo () {
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.elementoVistaBkUp = JSON.parse(JSON.stringify(this.elementoVista))
        this.autoresMiscelBkUp = JSON.parse(JSON.stringify(this.autoresMiscel))
        this.elementoSelBkUp = JSON.parse(JSON.stringify(this.elementoSel))
        this.blanquearElementoVista()
        this.activaModo('MAS')
        // this.setFocus()
      } else {
        this.elementoSel = this.elementoSelBkUp
        if (this.elementoSel.titulo) {
          this.elementoVista = JSON.parse(JSON.stringify(this.elementoVistaBkUp))
          this.autoresMiscel = JSON.parse(JSON.stringify(this.autoresMiscelBkUp))
          this.activaModo('S')
        } else {
          this.activaModo('INI')
        }
      }
    },
    blanquearElementoVista () {
      this.autoresMiscel = []
      this.elementoSel = []
      this.elementoVista = {}
    },
    cargarPortada (event) {
      // Asignamos la imagen a nuestra data
      const portada = event.target.files[0]
      // Si imagen > 500kB alertamos y salimos
      const tamaño = portada.size
      if (tamaño > 500000) {
        alert('El tamaño del archivo es: ' +
        Math.round(tamaño / 1000) +
        'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb')
      } else {
        // Cargamos la previsualización
        const reader = new FileReader()
        reader.readAsDataURL(portada)
        reader.onload = e => { this.elementoVista.imagen = e.target.result }
      }
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'S':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    }
  },
  computed: {
    autoresVista () {
      return this.autoresMiscel.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')
    },
    minDataLib () {
      return (this.elementoVista.titulo)
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    autoresVista () {
      this.cambioForm()
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imagen{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  box-shadow: rgb(53, 52, 52) 5px 5px 7px;
}
.imagen2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}
.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  cursor:default;
  transform: scale(1);
}
.icon-icoSubirImg {
  color: rgb(30, 85, 130);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
.icon-icoSubirImg:disabled {
     color: #8fa3ad;  /* no funciona */
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 576px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  article.Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    width:94%;
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
    margin-left:3%;
  }
  .Blk-Campo p{
    max-width: 80%;
  }
  .campo{
    width: 100%;
    margin: 0 0 0 0;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  textarea.campo, input.campo, div.campo{
    width: 97%;
    margin-left:0%;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .imagen2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }

}
</style>
